import FlowsManageData from './FlowsManageData';

export default FlowsManageData;
